import { useSideOverContext } from '../components';
import { useClientContext } from '../../ClientContext';
import { InvestmentType } from '../../generated/graphql';
import { useFeatureFlagsContext } from '../../FeatureFlags';
import { InvestmentFormSideOverPage } from './InvestmentFormSideOverPage';
import { createInvestmentServiceInputFromForm, useCreateInvestmentService, useInvestmentForm } from '../../Investment';

interface CreateInvestmentSideOverImplementationPageProps {
  investmentType: InvestmentType;
  exitRoute: string | undefined;
  successExitRoute: string | undefined;
}

export function CreateInvestmentSideOverImplementationPage({
  exitRoute,
  investmentType,
  successExitRoute,
}: CreateInvestmentSideOverImplementationPageProps) {
  const { closeSideOver } = useSideOverContext();
  const { allowDocuments } = useFeatureFlagsContext();
  const { firmID, clientID, householdID } = useClientContext();
  const { createInvestmentService } = useCreateInvestmentService();

  const useInvestmentFormReturn = useInvestmentForm({
    householdID,
    defaultValueOverrides: { investmentType },
    handleSubmit: (data) => {
      createInvestmentService.mutate(createInvestmentServiceInputFromForm(data), {
        onSuccess: () => closeSideOver(successExitRoute),
      });
    },
  });

  return (
    <InvestmentFormSideOverPage
      exit={exitRoute}
      firmID={firmID}
      clientID={clientID}
      investmentType={investmentType}
      allowDocuments={!!allowDocuments}
      isLoading={createInvestmentService.isLoading}
      useInvestmentFormReturn={useInvestmentFormReturn}
    />
  );
}
